import { useEffect, useState } from 'react';
import React from 'react';
import styles from './../../admin/styles.module.scss'
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '@store/types';

type leftNavOthers = {
    id: string,
    title: string, 
    url: string, 
    disabled?: boolean,
    iconRef?: any
};

const LeftNavOthers: React.FC<{selected_id: string}> = ({selected_id}) => {
    const [navListOther, setNavList]= useState<leftNavOthers[]>([]);
    const { envVariables: Env } = useSelector((store:RootState)=> store.AccountReducer);
    
    useEffect(() => {
        const nav: leftNavOthers[] =  [];

        Env?.REACT_SHOW_ASSET_HIERARCHY && nav.push(
            {
                id: 'asset',
                iconRef: '/icons/asset-hierarchy.svg',
                title: 'Asset Hierarchy',
                url: '/others/asset-hierarchy'
            }
        )
        !Env?.REACT_APP_DISABLE_GIT_INTEGRATION && nav.push(
            {
                id: 'git',
                title: 'Git Management',
                iconRef: '/icons/git-integration.svg',
                url: '/others/git-integration-settings'
            },
        )
        Env?.REACT_SHOW_PI_REQUESTS_TABLE && nav.push(
            {
                id: 'nifi',
                iconRef: '/icons/nifi.svg',
                title: 'Edge Management',
                url: '/others/nifi-management'
            }
        )
        setNavList(nav);
    }, [Env]);

    return (
        <div
            className={classNames(styles["treeview__container"])}
        >   
            <h2 className={styles["header"]}>Others</h2>
            <ul className="">
                {navListOther.map((tab) => (
                     <Link to={tab.url}  key={tab.id}>
                        <li
                            key={tab.id}
                            className={classNames( {
                                [styles["selected"]]: tab.id === selected_id,
                            })}
                        >
                            <Link to={tab.url}>
                                <img src={tab.iconRef} />
                                <span>{tab.title}</span>
                            </Link>
                        </li>
                     </Link>
                ))}
            </ul>
        </div>
    );
};

export default LeftNavOthers;
